import { useEffect, useState } from 'react';
import { Keyboard, Platform } from 'react-native';

/**
 * Custom hook to detect keyboard visibility state
 * Handles platform-specific keyboard events (iOS uses Will events, Android uses Did events)
 * @returns {boolean} True if keyboard is visible, false otherwise
 */
const useKeyboardVisibility = () => {
  const [isKeyboardVisible, setKeyboardVisible] = useState(false);

  useEffect(() => {
    const showEvent = Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow';
    const hideEvent = Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide';

    const handleShow = () => setKeyboardVisible(true);
    const handleHide = () => setKeyboardVisible(false);

    const keyboardShowListener = Keyboard.addListener(showEvent, handleShow);
    const keyboardHideListener = Keyboard.addListener(hideEvent, handleHide);

    return () => {
      keyboardShowListener.remove();
      keyboardHideListener.remove();
    };
  }, []);

  return isKeyboardVisible;
};

export default useKeyboardVisibility;